module.exports = __webpack_public_path__ + "img/DIMA_NATURAL_ARTWORK.jpg";